import React from 'react';
import { Table, FormControl } from 'react-bootstrap';

import Translate from '../../../../utils/Translate'

class CashFlow extends React.Component {

	handleChange = (field, value) => {
		this.props.inputChanged("cashFlow", field, value)
	}

	// New function to handle numeric input with zero handling
	handleNumericChange = (field, value) => {
		// Remove any non-digit characters except decimal point
		let numericValue = value.replace(/[^\d.]/g, '');
		
		// Remove leading zeros when typing, but allow zero as a value
		if (numericValue.startsWith('0') && numericValue.length > 1 && !numericValue.startsWith('0.')) {
			numericValue = numericValue.replace(/^0+/, '');
		}
		
		// If empty after cleaning, set to '0'
		if (numericValue === '') {
			numericValue = '0';
		}
		
		this.handleChange(field, numericValue);
	}

// Special handler for repayments field that allows + or - only at the start
// Special handler for repayments field that allows optional + or - at start
handleRepaymentsChange = (value) => {
    // Allow digits, decimal point, and optional leading + or -
    let repaymentsValue = value.replace(/[^0-9.+-]/g, '');

    // Only keep + or - at the start
    repaymentsValue = repaymentsValue.replace(/(?!^)[+-]/g, '');

    // Remove leading zeros after the sign, but keep '0' as valid
    repaymentsValue = repaymentsValue.replace(/^([+-]?)(0+)(\d)/, '$1$3');

    // If empty or only sign, set to '0'
    if (repaymentsValue === '' || repaymentsValue === '+' || repaymentsValue === '-') {
        repaymentsValue = '0';
    }

    this.handleChange("repayments", repaymentsValue);
}


	
	render() {
		let totalOperatingCashFlow = 0	
		totalOperatingCashFlow += (!isNaN(parseFloat(this.props.cashFlow.salesRevenue))) ? parseFloat(this.props.cashFlow.salesRevenue) : 0;
		totalOperatingCashFlow += (!isNaN(parseFloat(this.props.cashFlow.otherIncomes))) ? parseFloat(this.props.cashFlow.otherIncomes) : 0;
		totalOperatingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.materialPurchase))) ? parseFloat(this.props.cashFlow.materialPurchase) : 0;
		totalOperatingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.labour))) ? parseFloat(this.props.cashFlow.labour) : 0;
		totalOperatingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.indirectRAndDCosts))) ? parseFloat(this.props.cashFlow.indirectRAndDCosts) : 0;
		totalOperatingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.lease))) ? parseFloat(this.props.cashFlow.lease) : 0;
		totalOperatingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.indirectProductionCosts))) ? parseFloat(this.props.cashFlow.indirectProductionCosts) : 0;
		totalOperatingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.marketing))) ? parseFloat(this.props.cashFlow.marketing) : 0;
		totalOperatingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.storageCosts))) ? parseFloat(this.props.cashFlow.storageCosts) : 0;
		totalOperatingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.qualityAssurance))) ? parseFloat(this.props.cashFlow.qualityAssurance) : 0;
		totalOperatingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.indirectSalesCosts))) ? parseFloat(this.props.cashFlow.indirectSalesCosts) : 0;
		totalOperatingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.processOptimization))) ? parseFloat(this.props.cashFlow.processOptimization) : 0;
		totalOperatingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.otherOverheads))) ? parseFloat(this.props.cashFlow.otherOverheads) : 0;
		totalOperatingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.taxes))) ? parseFloat(this.props.cashFlow.taxes) : 0
		let investingCashFlow = 0;

		investingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.productDevelopmentCost))) ? parseFloat(this.props.cashFlow.productDevelopmentCost) : 0;
		investingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.productionFacilities))) ? parseFloat(this.props.cashFlow.productionFacilities) : 0;
		investingCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.machines))) ? parseFloat(this.props.cashFlow.machines) : 0;
		
		investingCashFlow += (!isNaN(parseFloat(this.props.cashFlow.saleOfFixedAssets))) ? parseFloat(this.props.cashFlow.saleOfFixedAssets) : 0;
		
		let totalIncomes = 0
		totalIncomes += (!isNaN(parseFloat(this.props.cashFlow.salesRevenue))) ? parseFloat(this.props.cashFlow.salesRevenue) : 0;
		totalIncomes += (!isNaN(parseFloat(this.props.cashFlow.otherIncomes))) ? parseFloat(this.props.cashFlow.otherIncomes) : 0;

		let totalOverhead = 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.materialPurchase))) ? parseFloat(this.props.cashFlow.materialPurchase) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.labour))) ? parseFloat(this.props.cashFlow.labour) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.indirectRAndDCosts))) ? parseFloat(this.props.cashFlow.indirectRAndDCosts) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.productDevelopmentCost))) ? parseFloat(this.props.cashFlow.productDevelopmentCost) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.productionFacilities))) ? parseFloat(this.props.cashFlow.productionFacilities) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.machines))) ? parseFloat(this.props.cashFlow.machines) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.lease))) ? parseFloat(this.props.cashFlow.lease) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.indirectProductionCosts))) ? parseFloat(this.props.cashFlow.indirectProductionCosts) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.marketing))) ? parseFloat(this.props.cashFlow.marketing) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.storageCosts))) ? parseFloat(this.props.cashFlow.storageCosts) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.qualityAssurance))) ? parseFloat(this.props.cashFlow.qualityAssurance) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.indirectSalesCosts))) ? parseFloat(this.props.cashFlow.indirectSalesCosts) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.processOptimization))) ? parseFloat(this.props.cashFlow.processOptimization) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.otherOverheads))) ? parseFloat(this.props.cashFlow.otherOverheads) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.interest))) ? parseFloat(this.props.cashFlow.interest) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.cashFlow.taxes))) ? parseFloat(this.props.cashFlow.taxes) : 0


		let financeCashFlow = 0;
		financeCashFlow += (!isNaN(parseFloat(this.props.cashFlow.repayments))) ? parseFloat(this.props.cashFlow.repayments) : 0;
		financeCashFlow -= (!isNaN(parseFloat(this.props.cashFlow.interest))) ? parseFloat(this.props.cashFlow.interest) : 0;

		let netCashFlow = 0
		netCashFlow = financeCashFlow + investingCashFlow +  totalOperatingCashFlow

		

		let cashLevelAtEnd = (!isNaN(parseFloat(this.props.cashFlow.cashLevelAtStart))) ? parseFloat(this.props.cashFlow.cashLevelAtStart) : 0;
		cashLevelAtEnd += netCashFlow;
		

		return (
			<Table bordered>
				<tbody>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Cash level at start of year" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.cashLevelAtStart }
								onChange={ (e) => this.handleNumericChange("cashLevelAtStart", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">+ <Translate alias="Forms" word="Sales revenue" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.salesRevenue }
								onChange={ (e) => this.handleNumericChange("salesRevenue", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">+ <Translate alias="Forms" word="Other incomes" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.otherIncomes }
								onChange={ (e) => this.handleNumericChange("otherIncomes", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					{/* <tr className="autofillFieldBackground">
						<td>
							<div className="bold"><Translate alias="Forms" word="Total Incomes" /></div>
						</td>
						<td>
							<FormControl aria-label="Small" size="sm" value={ totalIncomes } disabled />
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
					</tr> */}
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Materials purchase" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.materialPurchase }
								onChange={ (e) => this.handleNumericChange("materialPurchase", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Labour" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.labour }
								onChange={ (e) => this.handleNumericChange("labour", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Indirect R&D costs" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.indirectRAndDCosts }
								onChange={ (e) => this.handleNumericChange("indirectRAndDCosts", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Lease" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.lease }
								onChange={ (e) => this.handleNumericChange("lease", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Indirect production costs" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.indirectProductionCosts }
								onChange={ (e) => this.handleNumericChange("indirectProductionCosts", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Marketing" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.marketing }
								onChange={ (e) => this.handleNumericChange("marketing", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Storage costs" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.storageCosts }
								onChange={ (e) => this.handleNumericChange("storageCosts", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
							
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Quality assurance" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.qualityAssurance }
								onChange={ (e) => this.handleNumericChange("qualityAssurance", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Indirect sales costs" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.indirectSalesCosts }
								onChange={ (e) => this.handleNumericChange("indirectSalesCosts", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Process optimization" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.processOptimization }
								onChange={ (e) => this.handleNumericChange("processOptimization", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Other overheads" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.otherOverheads }
								onChange={ (e) => this.handleNumericChange("otherOverheads", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Taxes" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.taxes }
								onChange={ (e) => this.handleNumericChange("taxes", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>	
					<tr className="autofillFieldBackground">
						<td>
							<div className="bold"><Translate alias="Forms" word="Operating cash flow" /></div>
						</td>
						<td>
							<FormControl aria-label="Small" size="sm" value={ totalOperatingCashFlow } disabled />
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Product development cost" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.productDevelopmentCost }
								onChange={ (e) => this.handleNumericChange("productDevelopmentCost", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Purchase of production facilities" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.productionFacilities }
								onChange={ (e) => this.handleNumericChange("productionFacilities", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Purchase of machines" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.machines }
								onChange={ (e) => this.handleNumericChange("machines", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>


					<tr>
						<td>
							<div className="bold">+ <Translate alias="Forms" word="Sale of fixed assets" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.saleOfFixedAssets }
								onChange={ (e) => this.handleNumericChange("saleOfFixedAssets", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr className="autofillFieldBackground">
						<td>
							<div className="bold"><Translate alias="Forms" word="Investing cash flow" /></div>
						</td>
						<td>
							<FormControl aria-label="Small" size="sm" value={ investingCashFlow } disabled />
						</td>
					</tr>

					<tr>
						<td>
							<div className="bold">- <Translate alias="Forms" word="Interest" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.interest }
								onChange={ (e) => this.handleNumericChange("interest", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold">+/- <Translate alias="Forms" word="Credit take-ups/repayments" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.cashFlow.repayments }
								onChange={ (e) => this.handleRepaymentsChange(e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>

					<tr>
						<td></td>
						<td></td>
					</tr>
					<tr className="autofillFieldBackground">
						<td>
							<div className="bold"><Translate alias="Forms" word="Financial cash Flow" /></div>
						</td>
						<td>
							<FormControl aria-label="Small" size="sm" value={ financeCashFlow	 } disabled />
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td></td>
						<td></td>
					</tr>
					<tr className="autofillFieldBackground">
						<td>
							<div className="bold"><Translate alias="Forms" word="Net cash flow" /></div>
						</td>
						<td>
							<FormControl aria-label="Small" size="sm" value={ netCashFlow } disabled />
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
					</tr>
					<tr className="autofillFieldBackground">
						<td>
							<div className="bold"><Translate alias="Forms" word="Cash level at year end" /></div>
						</td>
						<td>
							<FormControl aria-label="Small" size="sm" value={ cashLevelAtEnd } disabled />
						</td>
					</tr>
				</tbody>
			</Table>
		);
	}

}

export default CashFlow;